import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Announcements from './pages/Announcements';
import Information from './pages/Information';
import Minutes from './pages/Minutes';
import Moving from './pages/Moving';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 antialiased">
      {/* Scroll to top on route change */}
      <ScrollToTop />

      {/* Navigation Bar */}
      <Navbar />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/meddelelser" element={<Announcements />} />
          <Route path="/information" element={<Information />} />
          <Route path="/moedereferater" element={<Minutes />} />
          <Route path="/meddel-flytning" element={<Moving />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
